/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_MariaInputs */

const en_onboarding_rating_maria = /** @type {(inputs: Onboarding_Rating_MariaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for my daily routine. The voice sounds natural and the app is super easy to use.`)
};

const es_onboarding_rating_maria = /** @type {(inputs: Onboarding_Rating_MariaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecta para mi rutina diaria. La voz suena natural y la app es súper fácil de usar.`)
};

/**
* | output |
* | --- |
* | "Perfect for my daily routine. The voice sounds natural and the app is super easy to use." |
*
* @param {Onboarding_Rating_MariaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_maria = /** @type {((inputs?: Onboarding_Rating_MariaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_MariaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_maria(inputs)
	return en_onboarding_rating_maria(inputs)
});